module.exports = __webpack_public_path__ + "files/14111e5fa0d2a56ade6e3a3b0ed43f1c.png";